module.exports = __webpack_public_path__ + "img/playbutton15.eead06b6.png";